import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.553 3.224a1 1 0 0 1 .894 0l8.764 4.382a1 1 0 0 1 0 1.788l-8.763 4.382a1 1 0 0 1-.895 0L2.789 9.394a1 1 0 0 1 0-1.788z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.315 12.695a.75.75 0 0 1 .99-.38l8.594 3.82a.25.25 0 0 0 .203 0l8.594-3.82a.75.75 0 0 1 .609 1.37l-8.594 3.82a1.75 1.75 0 0 1-1.421 0l-8.594-3.82a.75.75 0 0 1-.381-.99"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.305 16.315a.75.75 0 0 0-.61 1.37l8.595 3.82a1.75 1.75 0 0 0 1.421 0l8.594-3.82a.75.75 0 0 0-.61-1.37l-8.593 3.82a.25.25 0 0 1-.203 0z"
    }, null, -1)
  ])))
}
export default { render: render }